window.dataLayer = window.dataLayer || [];

export default {
  push: (e) => window.dataLayer.push(e),
};
